import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqData = {
    general: [
        { 
            question: { en: "How can I recover my forgotten password?", ps: " څنګه خپل هېر شوی رمز (پاسورډ) بېرته ترلاسه کړو؟", pr: "چگونه رمز عبور فراموش‌ شدهٔ خود را بازیابی کنیم؟" }, 
            answer: { 
                en: "To recover your password, click on the “Forgot Password” option on the login page. Then enter your registered email address to receive password recovery instructions.",
                ps: " د رمز (پاسورد) د بېرته ترلاسه کولو لپاره، سیستم ته د ننوتلو په پاڼه کې پر «ما خپل پاسورد هېر کړی» تڼۍ کیکاږي او وروسته خپل ثبت شوی ایمېل ادرس د ننه کړي ، تر څو د پاسورد د بېرته ترلاسه کولو لارښود تاسو ته واستول شي.",
                pr: "برای بازیابی رمز‌عبور، در صفحهٔ ورود روی گزینهٔ «رمز عبور را فراموش کرده‌ام» کلیک کنید. سپس با وارد کردن ایمیل ثبت‌ شدهٔ خود، دستورالعمل بازیابی رمز‌ عبور برایتان ارسال خواهد شد."
            }
        },
        { 
            question: { en: "How can I search for my desired course?", ps: " څنګه کولی شم د خپلي خوښي کورس وپلټم ؟", pr: "چگونه می‌ توانم کورس دلخواه خود را جستجو کنم؟" }, 
            answer: { 
                en: "In the top search bar of the system, enter the name of the course or topic you're looking for. Relevant courses will then be displayed.",
                ps: "د سیسټم په پورتنۍ برخه  د لټون په بار کې د خپلي خوښي کورس یا موضوع  ولیکئ، تر څو اړوند کورسونه درته ښکاره شي.",
                pr: "در نوار جستجو بالای سیستم، نام کورس یا موضوع مورد نظر خود را وارد کنید تا کورس‌ های مرتبط نمایش داده شوند."
            }
        },
        { 
            question: { en: "Is using HELP free of charge?", ps: "آیا د HELP کارول وړیا دي؟", pr: "آیا استفاده از HELP رایگان است؟" }, 
            answer: { 
                en: "Yes, all courses and system features are free for registered users.",
                ps: "بلي، د سیستم  ټول کورسونه او اسانتیاوې د راجستر شویو کار کوونکو لپاره وړیا دي.",
                pr: "بله، تمامی کورس و امکانات سیستم برای کاربران ثبت‌ نام‌ شده رایگان هستند."
            }
        }
    ],
    lms: [
        { 
            question: { en: "Can I download the courses?", ps: "ایا زه کولی شم کورسونه ډاونلوډ کړم؟", pr: "آیا میتوانم کورسها را دانلود کنم؟" }, 
            answer: { 
                en: "Yes, registered users can download educational courses for offline viewing. Just log into your account and select the download option on each video page.",
                ps: "بلي، راجستر شوی کارکوونکي کولی شي د زده کړې کورسونه د آفلاین لیدلو لپاره ډاونلوډ کړي. فقط خپل حساب ته ننوزئ او د هري ویډیو په  پاڼه کې د کورس ډاونلوډ انتخاب کړئ",
                pr: "بله، کاربران ثبت نام‌ شده میتوانند کورس‌ های آموزشی را برای مشاهده آفلاین دانلود کنند. کافی است وارد حساب کاربری خود شوید و گذینه دانلود کورس را در صفحه هر ویدیو انتخاب کنید."
            }
        },
        { 
            question: { en: "Does HELP offer educational content in multiple languages?", ps: "ایا HELP د زده کړې مواد په بېلابېلو ژبو وړاندې کوي؟", pr: "آیا HELP محتوای آموزشی را به زبان‌ های مختلف ارائه می ‌دهد؟" }, 
            answer: { 
                en: "Yes, courses are offered in Afghanistan’s national languages so that all users can easily benefit from the educational content",
                ps: "بلي، کورسونه د افغانستان په  ملي ژبو وړاندې کېږي ترڅو ټول کارکوونکي په آسانۍ سره د زده کړې له موادو ګټه پورته کړي.",
                pr: "بله، کورسها به زبانهای ملی افغانستان ارائه میشوند تا تمامی کاربران بتوانند به راحتی از محتوای آموزشی بهره‌مند شوند."
            }
        }
    ],
    other: [
        { 
            question: { en: "How can I contact customer support?", ps: "څنګه کولی شم د کارکوونکو خدمتونو له ټیم  سره اړیکه ونیسم؟", pr: "چگونه می‌توانم با خدمات کاربران تماس بگیرم؟" }, 
            answer: { 
                en: "At the bottom of each page, there is a “Contact Us” link. You can reach the support team via the contact form or email.",
                ps: "د هرې صفحې په ښکته برخه کې د «موږ سره اړیکه» لینک موجود دی.  دهمدي لینک نه په استفادي سره تاسو کولی شئ د اړیکې فورم یا ایمیل له لارې د کارکوونکو د خدمتونو ټیم سره تماس ونیسئ.",
                pr: "در پایین هر صفحه، لینک «تماس با ما» موجود است. می‌توانید از طریق فورم تماس یا ایمیل با تیم خدمات کاربران ارتباط برقرار کنید."
            }
        }
    ]
};

const FAQ = () => {
    const [selectedCategory, setSelectedCategory] = useState('general');
    const [activeQuestion, setActiveQuestion] = useState(null);
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language; // Get the current language from i18n

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        setActiveQuestion(null);
    };

    const handleQuestionToggle = (index) => {
        setActiveQuestion(activeQuestion === index ? null : index);
    };

    const renderFAQs = (faqs) => (
        faqs.map((item, index) => (
            <motion.div
                key={index}
                className="relative py-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
            >
                <div className="flex items-center cursor-pointer" onClick={() => handleQuestionToggle(index)}>
                    <span className="text-lg font-semibold flex-grow">{item.question[currentLang]}</span>
                    <motion.div
                        className="text-indigo-500 ml-4"
                        animate={{ rotate: activeQuestion === index ? 45 : 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {activeQuestion === index ? <FaMinus /> : <FaPlus />}
                    </motion.div>
                </div>
                <div className="overflow-hidden">
                    {activeQuestion === index && (
                        <div className="relative">
                            <motion.div
                                className="absolute inset-0 border-b border-indigo-500"
                                initial={{ width: 0 }}
                                animate={{ width: '100%' }}
                                transition={{ duration: 0.5 }}
                            />
                            <motion.p
                                className="text-gray-800 py-2"
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: 'auto' }}
                                transition={{ duration: 0.3 }}
                            >
                                {item.answer[currentLang]}
                            </motion.p>
                        </div>
                    )}
                </div>
            </motion.div>
        ))
    );

    return (
        <div className="w-full max-w-7xl mx-auto px-4 py-20">
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-center mb-6">{t("faq-full")}</h1>
                <div className="flex flex-wrap justify-center gap-4 mb-6">
                    {Object.keys(faqData).map((category) => (
                        <button
                            key={category}
                            className={`py-2 px-6 border rounded-lg transition-colors duration-300 ${selectedCategory === category ? 'bg-indigo-500 text-white' : 'bg-white text-gray-800 hover:bg-indigo-100'}`}
                            onClick={() => handleCategoryChange(category)}
                        >
                            <span className='capitalize'>{t(category)}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div>
                {renderFAQs(faqData[selectedCategory])}
            </div>
        </div>
    );
};

export default FAQ;
